import servicesData from '../../data/tiktokServices.json';

export default function Section8() {
    return (
        <div className="SectionCRO py-[60px] md:py-[50px] bg-gray-100">
            {/* Heading */}
            <div className="text-center mb-16 max-w-4xl mx-auto">
                <h2 className="text-[26px] md:text-[30px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
                    Our <span className="text-[#DA2128]">TikTok Marketing Services</span>
                </h2>
                <p className="mt-4 text-[#555] text-[16px] md:text-[18px] max-w-[600px] mx-auto">
                    At Mean3, we offer complete TikTok marketing solutions that help your brand grow across markets and languages.
                </p>
            </div>

            {/* Services Grid */}
            <div className="flex flex-wrap justify-center gap-12 md:gap-10 w-[90%] md:w-[85%] mx-auto">
                {servicesData.map((service, index) => (
                    <div
                        key={index}
                        className="flex flex-col items-center text-center transition transform hover:-translate-y-2 hover:scale-105 duration-300 p-6 rounded-2xl shadow-md bg-[#f5f5f5] w-full sm:w-[45%] md:w-[30%]"
                    >
                        {/* Icon */}
                        <div className="text-4xl md:text-5xl mb-4">{service.icon}</div>

                        {/* Title */}
                        <h3 className="text-[18px] md:text-[20px] font-semibold text-[#151515] mb-2">
                            {service.title}
                        </h3>

                        {/* Description */}
                        <p className="text-[#555] text-[14px] md:text-[15px] leading-[22px]">
                            {service.description}
                        </p>
                    </div>
                ))}
            </div>


        </div>
    );
}
